import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChatCategory, ChatFacadeService, ChatFactService } from '@hemro/lib/admin';
import { combineLatestWith, map, Observable, Subject, takeUntil } from 'rxjs';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-chat-onboarding',
    templateUrl: './chat-onboarding.component.html',
    styleUrl: './chat-onboarding.component.scss',
    animations: [
        trigger('listAnimation', [
            transition('* <=> *', [
                query(
                    ':enter',
                    [
                        style({ transform: 'translateY(-12px)', opacity: 0 }),
                    ],
                    { optional: true }
                ),
                query(
                    ':enter',
                    stagger('80ms', [
                        animate(
                            '280ms cubic-bezier(.2,.8,.2,1)',
                            style({ transform: 'translateY(0)', opacity: 1 })
                        ),
                    ]),
                    { optional: true }
                ),
            ]),
        ]),

        trigger('itemAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(-12px)', opacity: 0 }),
                animate(
                    '280ms cubic-bezier(.2,.8,.2,1)',
                    style({ transform: 'translateY(0)', opacity: 1 })
                ),
            ]),
        ]),
    ]
})
export class ChatOnboardingComponent implements OnInit, OnDestroy {
    categories: ChatCategory[] = [];
    categories$ = this.chatFacadeService.chatCategories$;
    selectedCategoryId$ = this.chatFacadeService.selectedCategoryId$;
    selectedSubCategoryId$ = this.chatFacadeService.selectedSubCategoryId$;

    selectedCategory$ = this.chatFacadeService.selectedCategoryId$
        .pipe(map(categoryId => this.categories.find(c => c.chatCategoryId === categoryId)));

    selectedSubCategory$ = this.selectedSubCategoryId$.pipe(
        combineLatestWith(this.selectedCategory$),
        map(([subCategoryId, category]) => {
            if (!subCategoryId || !category) {
                return null;
            }
            return category.subCategories.find(sc => sc.chatSubCategoryId === subCategoryId);
        })
    );

    get isCategorySet$(): Observable<boolean> {
        return this.selectedCategoryId$
            .pipe(
                combineLatestWith(this.selectedSubCategoryId$),
                map(([categoryId, subCategoryId]) => !!categoryId && !!subCategoryId)
            );
    }

    #unsubscribeAll = new Subject<void>();

    constructor(private chatFacadeService: ChatFacadeService,
                private chatFactService: ChatFactService) {
    }

    ngOnInit() {
        this.categories$
            .pipe(takeUntil(this.#unsubscribeAll))
            .subscribe(categories => this.categories = categories);
        this.chatFactService.queryAllCategories().subscribe(res => {
            this.chatFacadeService.chatCategories = res;
        });
    }

    ngOnDestroy(): void {
        this.#unsubscribeAll.next();
        this.#unsubscribeAll.complete();
    }

    selectCategory(categoryId: number) {
        this.chatFacadeService.setChatCategory(categoryId);
    }

    selectSubCategory(subCategoryId: number) {
        this.chatFacadeService.setSubChatCategory(subCategoryId);
    }

}
